/*This component comes into action upon clicking Start Fundraiser button on the Header
  and selecting New Fundraiser from the pop up window*/

import {
	DatePipe,
	NgIf,
	NgClass,
	NgFor,
	NgStyle,
	AsyncPipe,
	UpperCasePipe,
	DecimalPipe,
	CommonModule,
} from '@angular/common';
import {
	Component,
	Input,
	OnInit,
	ViewChild,
	HostListener,
	ElementRef,
} from '@angular/core';
import {
	AbstractControl,
	AsyncValidatorFn,
	FormGroup,
	UntypedFormControl,
	UntypedFormGroup,
	ValidationErrors,
	Validators,
	FormsModule,
	ReactiveFormsModule,
	NgModel,
	NgModelGroup,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
	DomSanitizer,
	SafeHtml,
	SafeResourceUrl,
} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter, finalize, map, mergeMap, tap } from 'rxjs/operators';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { categories } from 'src/app/pages/search/components/search/category-data';
import { DashboardService } from 'src/app/pages/user/dashboard/services/dashboard.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { environment } from 'src/environments/environment';
import { Tools } from 'src/utilities/tools';
import { Category } from '../../../models/category';
import { MediaFiles } from '../../../models/mediaFiles';
import { CategoryService } from '../../../services/category.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MediaService } from '../../../services/media.service';
import { AddBackgroundDialogComponent } from './add-background-dialog/add-background-dialog.component';
import { AddVideoBackgroundDialogComponent } from './add-video-background-dialog/add-video-background-dialog.component';
import { UploadImageVideoPopUpComponent } from './upload-image-video-pop-up/upload-image-video-pop-up.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import { any } from 'cypress/types/bluebird';
import { base64ToFile } from 'ngx-image-cropper';
import { BankService } from 'src/app/pages/user/profile/services/bank.service';
import { ProfileService } from 'src/app/pages/user/profile/services/profile.service';
import { AnalyticsService } from 'src/app/global/services/analytics.service';
import {
	debounceTime,
	distinctUntilChanged,
	switchMap,
	catchError,
} from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { CharacterNormalizationService } from '../../../services/character-normalization.service';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FundraiserContactComponent } from '../../shared/fundraiser-contact/fundraiser-contact.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NumericInputDirective } from '../../../directives/numeric-input.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { MatStepper } from '@angular/material/stepper';
import { event } from 'cypress/types/jquery';
import { MatDividerModule } from '@angular/material/divider';
import { Location } from '@angular/common';

@Component({
	selector: 'app-create-fundraiser',
	templateUrl: './create-fundraiser.component.html',
	styleUrls: ['./create-fundraiser.component.scss'],
	standalone: true,
	imports: [
		NgIf,
		PageLoaderComponent,
		FormsModule,
		ReactiveFormsModule,
		ExtendedModule,
		FlexModule,
		MatCardModule,
		MatStepperModule,
		MatFormFieldModule,
		MatIconModule,
		MatSelectModule,
		MatOptionModule,
		MatInputModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatDatepickerModule,
		MatSlideToggleModule,
		MatProgressSpinnerModule,
		CommonModule,
		NgClass,
		MatDividerModule,
		NgIf,
	],
	providers: [DatePipe],
})

/*
 * This class takes care of creating a new fundraiser-------------------------------------------------------------
 */
export class CreateFundraiserComponent implements OnInit {
	/*
	 * Global Variables-------------------------------------------------------------
	 */
	isLoading: boolean = true;
	slug: string = '';
	createFundraiserForm!: UntypedFormGroup;
	shareFundraiserForm!: UntypedFormGroup;
	parentFundraiser: any;
	isAddVideo: boolean = false;
	imageFiles: File[] = [];
	imgUrl: any[] = [];
	isVideo: boolean = false;
	embedVideoUrl: any[] = [];
	mediaFiles: MediaFiles[] = [];
	disableVideoSaveButton: boolean = true;
	categories: any;
	locations: any = [];
	isShowTotalAmountDonated: Boolean = true;
	isAllowConnected: Boolean = true;
	imagePath: any;
	imagePath_blob: any;
	videoPath: any;
	profileResponse: any;
	minEndDate: Date = new Date();
	public _categories = categories;
	selectedCategories: Category[] = [];
	isShareFundraiserFormValid: boolean = false;
	fundraiserLocalId: any;
	emptyContact: any = {};
	receivedForm: any;
	isFormValid: boolean = true;
	youtubeIframe!: SafeHtml | undefined;
	isMobileView: boolean = false;
	isDialogOpen: boolean = false;
	allCurrenciesData: any[] = [];
	filteredCurrencies: Observable<any[]> | undefined;
	currencySearchControl: FormControl = new FormControl(); // For search input
	currency: FormControl = new FormControl(); // For selected currency
	selectedCurrency: string = '';
	selectedSymbol: string = '';
	maxTargetAmount: number = 999999;
	isEditingSlug: boolean = false;
	parentFundraiserCount: any;
	showCountrySelection: any;
	stripeCountryList: any;
	isStripeCreated: any;
	selectedLanguage: FormControl = new FormControl(
		this.accountService.getLocaleId()
	);
	showTargetAmount = true;
	showEndDate = true;
	step: number = 3;
	languagecodes: any = [
		{
			id: 0,
			languageName: $localize`:@@languageChooser_en_button:EN - English`,
			language_code: 'en',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'en' +
				'/w=17',
		},
		{
			id: 1,
			languageName: $localize`:@@languageChooser_nl_button:NL - Nederlands`,
			language_code: 'nl',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'nl' +
				'/w=17',
		},
		{
			id: 2,
			languageName: $localize`:@@languageChooser_es_button:ES - Español`,
			language_code: 'es',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'es' +
				'/w=17',
		},
		{
			id: 3,
			languageName: $localize`:@@languageChooser_de_button:DE - Deutsch`,
			language_code: 'de',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'de' +
				'/w=17',
		},
		{
			id: 4,
			languageName: $localize`:@@languageChooser_fr_button:FR - Français`,
			language_code: 'fr',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'fr' +
				'/w=17',
		},
		{
			id: 5,
			languageName: $localize`:@@languageChooser_bg_button:BG - Bulgarian`,
			language_code: 'bg',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'bg' +
				'/w=17',
		},
		{
			id: 6,
			languageName: $localize`:@@languageChooser_hr_button:HR - Croatian`,
			language_code: 'hr',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'hr' +
				'/w=17',
		},
		{
			id: 7,
			languageName: $localize`:@@languageChooser_cs_button:CS - Czech`,
			language_code: 'cs',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'cs' +
				'/w=17',
		},
		{
			id: 8,
			languageName: $localize`:@@languageChooser_da_button:DA - Danish`,
			language_code: 'da',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'da' +
				'/w=17',
		},
		{
			id: 9,
			languageName: $localize`:@@languageChooser_fi_button:FI - Finnish`,
			language_code: 'fi',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'fi' +
				'/w=17',
		},
		{
			id: 10,
			languageName: $localize`:@@languageChooser_el_button:EL - Greek`,
			language_code: 'el',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'el' +
				'/w=17',
		},
		{
			id: 11,
			languageName: $localize`:@@languageChooser_hu_button:HU - Hungarian`,
			language_code: 'hu',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'hu' +
				'/w=17',
		},
		{
			id: 12,
			languageName: $localize`:@@languageChooser_it_button:IT - Italian`,
			language_code: 'it',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'it' +
				'/w=17',
		},
		{
			id: 13,
			languageName: $localize`:@@languageChooser_pl_button:PL - Polish`,
			language_code: 'pl',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'pl' +
				'/w=17',
		},
		{
			id: 14,
			languageName: $localize`:@@languageChooser_pt_button:PT - Portuguese`,
			language_code: 'pt',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'pt' +
				'/w=17',
		},
		{
			id: 15,
			languageName: $localize`:@@languageChooser_ro_button:RO - Romanian`,
			language_code: 'ro',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'ro' +
				'/w=17',
		},
		{
			id: 16,
			languageName: $localize`:@@languageChooser_sk_button:SK - Slovak`,
			language_code: 'sk',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'sk' +
				'/w=17',
		},
		{
			id: 17,
			languageName: $localize`:@@languageChooser_sv_button:SV - Swedish`,
			language_code: 'sv',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'sv' +
				'/w=17',
		},
		{
			id: 18,
			languageName: $localize`:@@languageChooser_uk_button:UK - Ukranian`,
			language_code: 'uk',
			languageIcon:
				'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
				'uk' +
				'/w=17',
		},
	];

	startFundraiserLocalStorage: any;
	selectedBeneficiary: any;

	beneficiaries: any = [
		{
			beneficiaryName: $localize`:@@beneficiaryChooser_yourself:Yourself`,
			beneficiary_code: 'yourself',
		},
		{
			beneficiaryName: $localize`:@@beneficiaryChooser_someoneElse:Someone Else`,
			beneficiary_code: 'someoneElse',
		},
		{
			beneficiaryName: $localize`:@@beneficiaryChooser_charity:Charity`,
			beneficiary_code: 'charity',
		},
	];

	createFundraiserFundTitle = $localize`:@@fundraiser_createFundraiser_fundraiser_title_Input: Fundraiser Title`;
	createFundraiserLocation = $localize`:@@fundraiser_createFundraiser_fundraiser_location: Location`;
	createFundraiserlinkname = $localize`:@@fundraiser_createFundraiser_linkName_Input: Link name`;
	TargetAmountPlaceholder = $localize`:@@fundraiser_connectFundraiser_targetAmount_label: Target Amount`;
	DateRangePlaceholder = $localize`:@@create_fundraiser_set_date_range: Set date range`;
	private locationSearch$ = new Subject<string>();
	profileName: string = '';
	public currentLanguageCode: string = '';
	@ViewChild('stepper', { static: false }) stepper!: MatStepper;
	stepperOrientation: 'horizontal' | 'vertical' = 'horizontal';
	labelPosition: 'end' | 'bottom' = 'end';
	resizeDisabled = false;
	profilePhone: string = '';
	profileEmail: string = '';
	profileId: string = '';
	descriptionInputVisible = false;
	showMediaSwitchPopup = false;
	mediaSwitchTarget: 'video' | 'image' | null = null;
	pendingVideoUrl: string | null = null;
	pendingIframeHtml: SafeHtml | null = null;
	@ViewChild('descriptionTextarea') descriptionTextarea!: ElementRef;
	private slugDebounceSubject = new Subject<string>();
	isSlugChecking = false;
	customUrlEnabled: boolean = false; // Flag to enable/disable custom URL input
	isHovered = false;
	bottomOffset: string = 'bottom-[10px]';
	textImage = $localize`:@@mediaSwitchPopup_imageText:image`;
	textVideo = $localize`:@@mediaSwitchPopup_videoText:video`;
	@ViewChild('currencyInput', { static: false }) currencyInputRef!: ElementRef;
	howItWorksHref: string = '';
	howItWorksURL = $localize`:@@how_it_works_url:article/enabledisable-connected-team-fundraisers-9poye0/`;

	/*
	 * Constructor Function-------------------------------------------------------------
	 * @param router
	 * @param notificationService
	 * @param fundraiserServicePse
	 * @param datepipe
	 * @param accountService
	 * @param sanitizer
	 */
	constructor(
		public router: Router,
		public notificationService: NotificationService,
		public fundraiserService: FundraiserService,
		public datepipe: DatePipe,
		public accountService: AccountService,
		public sanitizer: DomSanitizer,
		public categoryService: CategoryService,
		public dialog: MatDialog,
		public _dashboardService: DashboardService,
		public mediaService: MediaService,
		private breakpointObserver: BreakpointObserver,
		public _bankService: BankService,
		public profileService: ProfileService,
		public analyticsService: AnalyticsService,
		public charNormalizationService: CharacterNormalizationService,
		private location: Location
	) {}

	/*
	 * Lifecycle Hooks~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */
	ngOnInit(): void {
		if (window.innerWidth <= 699) {
			// Wait for a tick to ensure everything is rendered
			setTimeout(() => this.scrollToOffsetTop(), 0);
		}
		this.scrollToOffsetTop();
		// ✅ Validate essential data first
		if (!this.validateStartFundraiserData()) {
			this.router.navigate(['/fundraising/start']);
			return;
		}
		window.addEventListener('scroll', this.handleScroll.bind(this));
		this.handleScroll();
		this.isLoading = true;

		this.checkLoginStatus();
		this.updateLabelPosition();
		window.addEventListener('orientationchange', this.onResize.bind(this));
		// Check login status - if not logged in, navigate to the login screen
		this.currentLanguageCode = this.accountService.getLocaleId();
		this.currencySearchControl.valueChanges.subscribe((value) => {
			if (value) {
				this.currencySearchControl.setValue(value.toUpperCase(), {
					emitEvent: false,
				});
			}
		});
		this.slugDebounceSubject
			.pipe(
				debounceTime(600),
				distinctUntilChanged(),
				filter((slug: string) => /^[a-zA-Z0-9_-]*$/.test(slug)),
				tap(() => (this.isSlugChecking = true)),
				switchMap((slug: string) =>
					this.fundraiserService
						.isSlugUnique(slug)
						.pipe(catchError(() => of(null)))
				)
			)
			.subscribe((result: any) => {
				const slugControl = this.createFundraiserForm.get('custom_url');

				if (result?.data?.slug_in_use) {
					slugControl?.setErrors({ ...slugControl.errors, slugInUse: true });
				} else if (slugControl?.errors) {
					const errors = { ...slugControl.errors };
					delete errors['slugInUse'];
					slugControl.setErrors(Object.keys(errors).length ? errors : null);
				}

				this.isSlugChecking = false; // ✅ Moved here to ensure it's always called
			});
		// const langSegment =
		// 	this.currentLanguageCode === 'en' ? '' : `${this.currentLanguageCode}/`;
		// this.howItWorksHref = `https://helpdesk.whydonate.com/${langSegment}${this.howItWorksURL}`;
		this.howItWorksHref = `https://helpdesk.whydonate.com/${this.currentLanguageCode}/${this.howItWorksURL}`;
	}

	ngAfterViewInit(): void {
		if (window.innerWidth <= 699) {
			// Wait for a tick to ensure everything is rendered
			setTimeout(() => this.scrollToOffsetTop(), 0);
		}
		this.handleScroll();
		this.currencyInputRef?.nativeElement?.addEventListener('blur', () => {
			this.currencySearchControl.markAsTouched();
		});
	}

	updateLabelPosition(): void {
		this.breakpointObserver
			.observe(['(max-width: 699px)'])
			.subscribe(({ matches }) => {
				if (!this.resizeDisabled) {
					this.labelPosition = matches ? 'bottom' : 'end';
				}
			});
	}

	@HostListener('focusin', ['$event'])
	onInputFocus(event: FocusEvent): void {
		if ((event.target as HTMLElement).tagName === 'INPUT') {
			this.resizeDisabled = true;
			setTimeout(() => {
				this.resizeDisabled = false;
			}, 180000);
		}
	}

	onResize(): void {
		if (!this.resizeDisabled) {
			this.updateLabelPosition();
		}
	}

	private checkLoginStatus(): void {
		this.accountService.getLoginInformation().subscribe(
			(info: any) => {
				if (!info) {
					this.router.navigate(['account/register']);
					return;
				}

				this.subscribeToViewportChanges();
				this.getStripeAccountStatus();
				this.fetchAllCurrencies();
				this.handleCurrencySelectionChanges();
				this.checkHeadersAndFetchProfile();
				this.getCategoryList();
			},
			(error: any) => {
				console.error('Error checking login information:', error);
			}
		);
	}

	private subscribeToViewportChanges(): void {
		this.breakpointObserver
			.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
			.subscribe((result) => {
				this.isMobileView = result.matches;
			});
	}

	private getStripeAccountStatus(): void {
		this._bankService.getStripeStatus(true).subscribe(
			(res: any) => {
				this.isStripeCreated = res?.data?.status;
				if (!this.isStripeCreated) {
					this.getParentFundraiserCount();
				} else {
					this.initializeCreateFundraiserForm();
				}
			},
			(error: any) => {
				console.error('Error fetching Stripe status:', error);
			}
		);
	}

	private getParentFundraiserCount(): void {
		this._dashboardService.getFundraiserSummary().subscribe(
			(res: any) => {
				this.parentFundraiserCount = res?.data?.parent;
				if (!this.parentFundraiserCount || !this.isStripeCreated) {
					this.router.navigate(['fundraising/country']);
					return;
				}
				this.initializeCreateFundraiserForm();
			},
			(error: any) => {
				console.error('Error fetching fundraiser summary:', error);
			}
		);
	}

	private fetchAllCurrencies(): void {
		this.fundraiserService.getAllCurrencies().subscribe(
			(res: any) => {
				this.allCurrenciesData = res?.data?.list_of_currencies || [];
				this.initializeFilter(); // Initialize the filteredCurrencies Observable
			},
			(error: any) => {
				console.error('Error fetching currencies:', error);
			}
		);
	}

	private handleCurrencySelectionChanges(): void {
		this.currencySearchControl = new FormControl('', [
			Validators.required,
			this.validateCurrency.bind(this)
		]);
		this.currencySearchControl.valueChanges.subscribe((currency_code: any) => {
			this.selectedCurrency = currency_code;
			const filteredCurrency = this.allCurrenciesData.find(
				(currencyData: any) => currencyData.currency === currency_code
			);

			if (filteredCurrency) {
				this.selectedSymbol = filteredCurrency.symbol;
				this.getMaxTargetAmountForCurrency(currency_code);
			}
		});
	}
	
	validateCurrency(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		if (!value) return null;
		
		const isMatch = this.allCurrenciesData?.some(
			(item: any) => item.currency.toLowerCase() === value.toLowerCase()
		);
		
		return isMatch ? null : { invalidCurrency: true };
	}


	private getMaxTargetAmountForCurrency(currency_code: string): void {
		const targetAmountControl = this.createFundraiserForm.get('target_amount');
		this.fundraiserService
			.getMaxTargetAmountByCurrency(currency_code)
			.subscribe(
				(res: any) => {
					this.maxTargetAmount =
						res?.data?.list_of_currencies[0]?.max_target_amount || 999999;
					targetAmountControl?.setValidators([
						Validators.max(this.maxTargetAmount),
						Validators.pattern('^[0-9]+$'),
					]);
					targetAmountControl?.updateValueAndValidity();
				},
				(error: any) => {
					console.error('Error fetching max target amount:', error);
				}
			);
	}

	private checkHeadersAndFetchProfile(): void {
		if (this.accountService.checkHeaders()) {
			this.profileService.getProfile().subscribe(
				(res: any) => {
					this.profileResponse = res?.data;
					this.profileId = res?.data?.profile?.id;
					this.profileName = res?.data?.profile?.name;
					this.profilePhone = res?.data?.profile?.phone_number;
					this.profileEmail = res?.data?.profile?.email;
				},
				(error: any) => {
					console.error('Error fetching profile:', error);
				}
			);
		}
	}

	private initializeCreateFundraiserForm(): void {
		this.createFundraiserForm = new UntypedFormGroup({
			title: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(5),
				Validators.maxLength(75),
				Validators.pattern(
					/^[\p{L}\p{N}\p{P}\p{S}\s\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAC0}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{2B05}\u{1F004}]*$/u
				),
			]),
			custom_url: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(5),
				Validators.maxLength(75),
				Validators.pattern('^[a-zA-Z0-9_-]*$'),
			]),
			target_amount: new UntypedFormControl('', [
				Validators.max(this.maxTargetAmount),
				Validators.pattern('^[0-9]+$'),
			]),
			end_date: new UntypedFormControl('', []),
			description: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(15),
				Validators.maxLength(15000),
			]),
			VideoName: new FormControl('', {
				validators: [],
				asyncValidators: [this.isValidVideoURL()],
				updateOn: 'blur',
			}),
			imagePath: new UntypedFormControl(''), // Add imagePath
			imagePath_blob: new UntypedFormControl(''), // Add imagePath_blob
		});

		let localStorageData = localStorage.getItem('start_fundraiser');
		this.startFundraiserLocalStorage = localStorageData
			? JSON.parse(localStorageData)
			: null;

		if (this.startFundraiserLocalStorage) {
			this.createFundraiserForm
				.get('beneficiary')
				?.setValue(this.startFundraiserLocalStorage.beneficiary);

			this.selectedBeneficiary = this.startFundraiserLocalStorage.beneficiary;

			this.prefillForm(this.startFundraiserLocalStorage);
			this.showTargetAmount =
				this.startFundraiserLocalStorage.showTargetAmount ?? true;
			this.showEndDate = this.startFundraiserLocalStorage.showEndDate ?? true;
			this.isShowTotalAmountDonated =
				this.startFundraiserLocalStorage.isShowTotalAmountDonated ?? true;
			this.isAllowConnected =
				this.startFundraiserLocalStorage.isAllowConnected ?? true;

			if (this.startFundraiserLocalStorage.currency) {
				const selectedCurrencyData = this.allCurrenciesData.find(
					(c: any) => c.currency === this.startFundraiserLocalStorage.currency
				);

				if (selectedCurrencyData) {
					this.currencySearchControl.setValue(selectedCurrencyData.currency);
					this.selectedCurrency = selectedCurrencyData.currency;
				}
			}

			// Restore imagePath and imagePath_blob from stored data
			if (this.startFundraiserLocalStorage.imagePath_blob) {
				const blob = base64ToFile(
					this.startFundraiserLocalStorage.imagePath_blob
				);
				this.imagePath = URL.createObjectURL(blob);
				this.imagePath_blob = this.startFundraiserLocalStorage.imagePath_blob;
				this.createFundraiserForm.get('imagePath')?.setValue(this.imagePath);
				this.createFundraiserForm
					.get('imagePath_blob')
					?.setValue(this.imagePath_blob);
			}
			setTimeout(() => {
				const form = this.createFundraiserForm;
				if (
					form.get('title')?.valid &&
					form.get('custom_url')?.valid &&
					form.get('description')?.valid &&
					(form.get('VideoName')?.valid || form.get('imagePath_blob')?.value)
				) {
					this.step = 4;
				}
			});
		}

		this.isLoading = false;

		// Subscribe to all form changes and update local storage
		this.createFundraiserForm.valueChanges
			.pipe(debounceTime(300))
			.subscribe((formValue) => {
				if (!this.startFundraiserLocalStorage) {
					this.startFundraiserLocalStorage = {};
				}

				// Extract video URL and rename the key
				const { VideoName, ...rest } = formValue;

				this.startFundraiserLocalStorage = {
					...this.startFundraiserLocalStorage,
					...rest,
					video: VideoName, // Use 'video' consistently
					currency: this.selectedCurrency,
					showTargetAmount: this.showTargetAmount,
					showEndDate: this.showEndDate,
					isShowTotalAmountDonated: this.isShowTotalAmountDonated,
					isAllowConnected: this.isAllowConnected,
				};

				localStorage.setItem(
					'start_fundraiser',
					JSON.stringify(this.startFundraiserLocalStorage)
				);
			});
	}

	prefillForm(data: any) {
		this.selectedLanguage.setValue(
			data.language_code || this.accountService.getLocaleId()
		);
		this.createFundraiserForm.get('name')?.setValue(data.name || '');
		this.createFundraiserForm.get('category')?.setValue(data.category || '');
		this.createFundraiserForm.get('title')?.setValue(data.title || '');
		this.createFundraiserForm
			.get('custom_url')
			?.setValue(data.custom_url || '');
		this.createFundraiserForm
			.get('target_amount')
			?.setValue(data.target_amount || '');
		this.createFundraiserForm.get('end_date')?.setValue(data.end_date || '');
		this.createFundraiserForm
			.get('description')
			?.setValue(data.description || '');
		// ✅ Toggle visibility if description exists
		this.descriptionInputVisible = !!data.description;
		this.createFundraiserForm.get('VideoName')?.setValue(data.video || '');

		if (data.video) {
			this.getLinkType(data.video);
		}
		if (this.selectedBeneficiary == 'yourself') {
			this.createFundraiserForm.get('location')?.setValue(data.location_locale);
			const location = { description: data.location_locale };
			if (
				!this.locations.some(
					(loc: any) => loc.description === data.location_locale
				)
			) {
				this.locations.push(location);
			}
		}
	}

	validateStartFundraiserData(): boolean {
		const data = localStorage.getItem('start_fundraiser');
		if (!data) return false;

		try {
			const parsed = JSON.parse(data);
			const hasBasicFields =
				parsed.language_code &&
				parsed.location_locale &&
				parsed.category &&
				parsed.beneficiary;

			if (!hasBasicFields) return false;

			// For 'someoneElse' or 'charity', name must be present
			if (
				(parsed.beneficiary === 'someoneElse' ||
					parsed.beneficiary === 'charity') &&
				!parsed.name
			) {
				return false;
			}

			return true;
		} catch {
			return false;
		}
	}

	// Initialize the filter logic for currency search
	private initializeFilter(): void {
		this.filteredCurrencies = this.currencySearchControl.valueChanges.pipe(
			startWith(''),
			map((searchTerm: string) => this.filterCurrencies(searchTerm || ''))
		);
	}

	// Filter currencies based on search term
	private filterCurrencies(searchTerm: string): any[] {
		const lowerCaseTerm = searchTerm.toLowerCase();
		return this.allCurrenciesData.filter((currencyData: any) =>
			currencyData.currency.toLowerCase().includes(lowerCaseTerm)
		);
	}

	// Handle currency selection
	onCurrencySelect(selectedCurrencyData: any): void {
		this.currency.setValue(selectedCurrencyData.currency);

		// ✅ Blur the input to hide the keyboard
		setTimeout(() => {
			this.currencyInputRef?.nativeElement?.blur();
		}, 100); // small delay to ensure the selection is registered
	}

	/*
	 * Image And Video Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */
	openImageCropperDialog() {
		if (this.videoPath) {
			this.mediaSwitchTarget = 'image';
			this.showMediaSwitchPopup = true;
			return;
		}
		const fileInput = document.getElementById(
			'upload_image_input'
		) as HTMLInputElement;

		// Check if the dialog is already open
		if (this.isDialogOpen) {
			return;
		}

		// Add event listener to handle file selection
		const handleChange = (event: Event) => {
			const inputElement = event.target as HTMLInputElement;
			if (inputElement.files && inputElement.files.length > 0) {
				const selectedFile = inputElement.files[0];
				const selectedFilePath = URL.createObjectURL(selectedFile);
				const mimeType = selectedFile.type;

				if (mimeType === 'image/gif') {
					this.mediaService
						.convertFileToBase64(selectedFile)
						.then((base64String) => {
							this.imagePath = URL.createObjectURL(base64ToFile(base64String));
							this.imagePath_blob = base64String;
							// Update form controls
							this.createFundraiserForm
								.get('imagePath')
								?.setValue(this.imagePath);
							this.createFundraiserForm
								.get('imagePath_blob')
								?.setValue(this.imagePath_blob);
							// Update local storage
							const formData = JSON.parse(
								localStorage.getItem('formData') || '{}'
							);
							formData.imagePath_blob = this.imagePath_blob;
							localStorage.setItem('formData', JSON.stringify(formData));
						});
				} else {
					const reader = new FileReader();
					reader.onload = (e: any) => {
						const base64 = e.target.result;
						const img = new Image();
						img.src = base64;

						img.onload = () => {
							const aspectRatio = img.width / img.height;
							const canvasAspect = 2 / 1;

							if (aspectRatio < canvasAspect) {
								this.applyBlurBackground(img);
							} else {
								const dialogRef = this.dialog.open(
									AddBackgroundDialogComponent,
									{
										data: {
											imagePath: selectedFilePath,
											autoFocus: false,
										},
									}
								);
								dialogRef.componentInstance.valueSelected.subscribe(
									(selectedValue: any) => {
										const base64Blob = selectedValue;
										const file = base64ToFile(base64Blob);
										const objectURL = URL.createObjectURL(file);

										this.imagePath = objectURL;
										this.imagePath_blob = base64Blob;

										// Update form controls
										this.createFundraiserForm
											.get('imagePath')
											?.setValue(this.imagePath);
										this.createFundraiserForm
											.get('imagePath_blob')
											?.setValue(this.imagePath_blob);

										// Update local storage
										const formData = JSON.parse(
											localStorage.getItem('formData') || '{}'
										);
										formData.imagePath_blob = this.imagePath_blob;
										localStorage.setItem('formData', JSON.stringify(formData));
									}
								);
							}
						};
					};
					reader.readAsDataURL(selectedFile);
				}
			}
			this.isDialogOpen = false;
			inputElement.value = '';
			fileInput?.removeEventListener('change', handleChange);
		};

		fileInput?.addEventListener('change', handleChange);
		fileInput?.click();
	}

	applyBlurBackground(img: HTMLImageElement): void {
		const width = 1600;
		const height = 800;

		// Step 1: Create SVG with Gaussian blur filter
		const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <filter id="blurFilter">
        <feGaussianBlur stdDeviation="40" />
      </filter>
      <image href="${img.src}" width="${width}" height="${height}" filter="url(#blurFilter)" preserveAspectRatio="xMidYMid slice"/>
    </svg>`;
		const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
		const svgUrl = URL.createObjectURL(svgBlob);

		const blurredImg = new Image();
		const originalImg = new Image();

		blurredImg.crossOrigin = 'anonymous';
		originalImg.crossOrigin = 'anonymous';

		blurredImg.onload = () => {
			originalImg.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				const ctx = canvas.getContext('2d');
				if (!ctx) return;

				// Draw blurred SVG background
				ctx.clearRect(0, 0, width, height);
				ctx.drawImage(blurredImg, 0, 0, width, height);

				// Draw sharp foreground image centered
				const ratio = Math.min(
					width / originalImg.width,
					height / originalImg.height
				);
				const newWidth = originalImg.width * ratio;
				const newHeight = originalImg.height * ratio;
				const offsetX = (width - newWidth) / 2;
				const offsetY = (height - newHeight) / 2;

				ctx.drawImage(originalImg, offsetX, offsetY, newWidth, newHeight);

				// Export canvas to image
				canvas.toBlob((blob) => {
					if (!blob) return;

					const blurredFile = new File([blob], 'blurred-background.png', {
						type: 'image/png',
					});

					const dialogRef = this.dialog.open(AddBackgroundDialogComponent, {
						data: {
							imagePath: URL.createObjectURL(blurredFile),
							autoFocus: false,
						},
					});

					dialogRef.componentInstance.valueSelected.subscribe(
						(selectedValue: any) => {
							this.imagePath = URL.createObjectURL(base64ToFile(selectedValue));
							this.imagePath_blob = selectedValue;

							// Update form controls
							this.createFundraiserForm
								.get('imagePath')
								?.setValue(this.imagePath);
							this.createFundraiserForm
								.get('imagePath_blob')
								?.setValue(this.imagePath_blob);

							// Update local storage
							const formData = JSON.parse(
								localStorage.getItem('formData') || '{}'
							);
							formData.imagePath_blob = this.imagePath_blob;
							localStorage.setItem('formData', JSON.stringify(formData));
						}
					);

					// Cleanup
					URL.revokeObjectURL(svgUrl);
				}, 'image/png');
			};

			originalImg.src = img.src;
		};

		blurredImg.src = svgUrl;
	}
	// openVideoDialog() {
	// 	const dialogRef = this.dialog.open(AddVideoBackgroundDialogComponent, {
	// 		data: {
	// 			videoPath: this.videoPath,
	// 			autoFocus: false,
	// 		},
	// 		width: '500px',
	// 	});

	// 	dialogRef.afterClosed().subscribe((update: any) => {
	// 		if (update) {
	// 			this.videoPath = update; // Update the video path
	// 			this.youtubeIframe = this.checkVideoUrl(update);
	// 			// stepper.next(); //
	// 		}
	// 	});
	// }

	// openimagepopup() {
	// 	const dialogRef = this.dialog.open(UploadImageVideoPopUpComponent, {
	// 		width: '500px',
	// 		data: { videoPath: this.videoPath, imagePath: this.imagePath },
	// 	});

	// 	dialogRef.componentInstance.valueSelected.subscribe(
	// 		(selectedValue: any) => {
	// 			this.getLinkType(selectedValue);
	// 		}
	// 	);
	// }

	// openvideopopup() {
	// 	const dialogRef = this.dialog.open(UploadImageVideoPopUpComponent, {
	// 		width: '500px',
	// 		data: { videoPath: this.videoPath, imagePath: this.imagePath },
	// 	});

	// 	dialogRef.componentInstance.valueSelected.subscribe(
	// 		(selectedValue: any) => {
	// 			this.getLinkType(selectedValue);
	// 		}
	// 	);
	// }

	// Check if it is a file ot url. It is to change between iframe and image after popup call.
	getLinkType(this: any, link: string): void {
		// Check if it is a Blob URL
		if (link.startsWith('blob:')) {
			this.videoPath = null;
			this.imagePath = URL.createObjectURL(base64ToFile(link));
			this.imagePath_blob = link;
			return;
		}

		// Check if it is a base64 image data
		if (link.startsWith('data:image')) {
			this.videoPath = null;
			this.imagePath = URL.createObjectURL(base64ToFile(link));
			this.imagePath_blob = link;
			return;
		}

		// Check if it is a YouTube URL using regex
		const youtubeRegex =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;
		if (youtubeRegex.test(link)) {
			this.youtubeIframe = this.generateYouTubeIframe(link);
			this.videoPath = link;
			this.imagePath = null;
			return;
		}

		// Check if it is a Vimeo URL using regex
		const vimeoRegex =
			/^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;
		if (vimeoRegex.test(link)) {
			this.youtubeIframe = this.generateVimeoIframe(link);
			this.videoPath = link;
			this.imagePath = null;
			return;
		}

		// Default case: unknown link type
		this.videoPath = null;
		this.imagePath = null;
	}

	checkVideoUrl(url: string) {
		// Vimeo link pattern
		const vimeoPattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;

		// YouTube link pattern (including Shorts)
		const youtubePattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;

		if (url?.match(vimeoPattern)) {
			return this.generateVimeoIframe(url);
		} else if (url?.match(youtubePattern)) {
			return this.generateYouTubeIframe(url);
		} else {
			return 'unknown';
		}
	}

	generateVimeoIframe(videoLink: string): SafeHtml {
		const vimeoVideoId = this.getVideoIdVimeo(videoLink);

		const angularTag = `
			<iframe
				fxFill
				width="100%"
				height="100%"
				id="create_fundraiser_Iframe"
				frameborder="0"
				allowfullscreen
				src="https://player.vimeo.com/video/${vimeoVideoId}"
				title="Vimeo Video"
			></iframe>
  
			`;

		// Sanitize the HTML tag using DomSanitizer
		const safeHTML = this.sanitizer.bypassSecurityTrustHtml(angularTag);

		return safeHTML;
	}

	generateYouTubeIframe(videoLink: string): SafeHtml {
		const videoId = this.getVideoIdYoutube(videoLink);
		const angularTag = `
			<iframe
				loading = "lazy"
				width="100%"
				height="100%"
				id="create_fundraiser_Iframe"
				fxfill
				src="https://www.youtube-nocookie.com/embed/${videoId}"
				title="The Youtube Video"
			></iframe>`;
		// Sanitize the HTML tag using DomSanitizer
		const safeHTML = this.sanitizer.bypassSecurityTrustHtml(angularTag);
		return safeHTML;
	}

	getVideoIdYoutube(videoLink: string): string {
		// Extract the video ID from the YouTube link (including Shorts)
		const pattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	getVideoIdVimeo(videoLink: string): string {
		// Extract the video ID from the Vimeo link
		const pattern = /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}
	/*
	 * Convert data uri to blob-----------------------------------------------
	 */
	dataURItoBlob(dataURI: any) {
		var byteString = atob(dataURI.toString().split(',')[1]);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], { type: 'image/jpeg' });
	}

	/*
	 * Form Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	getCategoryList() {
		this.categoryService.getCategorylist().subscribe((response: any) => {
			this.categories = JSON.parse(JSON.stringify(response))['data'];
		});
	}

	/*
	 * Slug (Custom Url) Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	setSlug(event: Event): void {
		const input = event.target as HTMLInputElement;
		let slug = input.value;

		// Normalize and remove emojis
		const normalized = this.charNormalizationService.normalizeString(slug);
		const sanitized = this.removeEmojis(normalized);

		// Replace whitespace with hyphens
		const slugified = sanitized.trim().toLowerCase().replace(/\s+/g, '-');

		// Update the form control without triggering its valueChanges
		this.createFundraiserForm?.controls['custom_url'].setValue(slugified, {
			emitEvent: true,
		});

		// Mark both fields as touched
		this.createFundraiserForm.controls['custom_url'].markAsTouched();
		this.createFundraiserForm.controls['title'].markAsTouched();

		// Trigger uniqueness check with debounce
		this.slugDebounceSubject.next(slugified);
	}

	onCustomUrlToggle(checked: boolean): void {
		this.customUrlEnabled = checked;
	}
	/*
	 * Miscellaneous Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	changeShowTotalAmountDonated() {
		this.isShowTotalAmountDonated = !this.isShowTotalAmountDonated;
	}

	changeAllowConnectedFundraiser() {
		this.isAllowConnected = !this.isAllowConnected;
	}

	/*
	 * Social Media  Validator Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	getYouTubeEmbedUrl(videoPath: string): SafeResourceUrl {
		// Construct the YouTube embed URL
		const videoId = this.extractVideoId(videoPath);
		const embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
			`https://www.youtube.com/embed/${videoId}`
		);
		return embedUrl;
	}

	extractVideoId(url: string): string | undefined {
		const match = url.match(
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/|shorts\/)?([^\s/?&]+)/i
		);
		return match?.[1];
	}

	clearVideoUrl(): void {
		this.videoPath = null;
		this.youtubeIframe = undefined;
		this.createFundraiserForm.get('VideoName')?.setValue('');
	}

	/*
	 * Save Fundraiser~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */
	saveFundraiser() {
		this._dashboardService.clearCache();
		this.createFundraiserForm.markAllAsTouched();
		if (this.createFundraiserForm.valid) {
			this.isLoading = true;

			/** *Check for unlimited */
			let unlimited: boolean = false;
			let amount_target: string =
				this.createFundraiserForm.get('target_amount')?.value;
			if (
				amount_target == null ||
				amount_target == undefined ||
				amount_target.length <= 0 ||
				amount_target == '0'
			) {
				unlimited = true;
				amount_target = '0';
			}

			/** *Retrieve end_date in proper format */
			let end_date = this.datepipe.transform(
				this.createFundraiserForm.get('end_date')?.value,
				'yyyy-MM-dd'
			);
			if (end_date == null || end_date == undefined) {
				end_date = this.datepipe.transform(
					new Date('9999-12-31'),
					'yyyy-MM-dd'
				);
			}

			let location_local: string = '';
			this.locations.forEach((location: any) => {
				if (
					location['description'] ==
					this.createFundraiserForm.get('location')?.value
				) {
					if (location['description']) {
						location_local = location['description'];
					} else {
						location_local = this.createFundraiserForm.get('location')?.value;
					}
				}
			});

			let isFirstFundraiser = false;
			this._dashboardService
				.getFundraiserSummary()
				.subscribe((response: any) => {
					this.parentFundraiserCount = response?.data?.parent || 0;
					if (this.parentFundraiserCount == 0) {
						isFirstFundraiser = true;
						this.fundraiserService.setParentFundraiserCount('firstFundraiser');
					}
				});

			/** *Create Object To Pass To API */
			const startFundraiserLocalData = JSON.parse(
				localStorage.getItem('start_fundraiser') || '{}'
			);
			const localImageBlob =
				this.createFundraiserForm.get('imagePath_blob')?.value;

			const createFundraiser = {
				title: this.createFundraiserForm.get('title')?.value,
				slug: this.createFundraiserForm.get('custom_url')?.value,
				category_id: startFundraiserLocalData.category,
				location_local: startFundraiserLocalData.location_locale,
				language_code: startFundraiserLocalData.language_code,
				unlimited: unlimited,
				currency_code: this.selectedCurrency,
				end_date: end_date,
				show_donation_details: this.isShowTotalAmountDonated,
				allow_child: this.isAllowConnected,
				tip_enabled: true,
				is_draft: false,
				created_on: (() => {
					const currentUrl = window.location.origin;
					return currentUrl.includes('localhost')
						? 'https://whydonate.in'
						: currentUrl;
				})(),
				video: this.videoPath,
				amount_target: amount_target,
				beneficiaryName: startFundraiserLocalData.name,
			};

			if (this.accountService.checkHeaders()) {
				this.fundraiserService
					.createFundraiser(createFundraiser)
					.pipe(
						map((response: any) => {
							if (response['status'] == 200) {
								this.notificationService.openNotification(
									$localize`:@@create_fundraiser_fundraiserCreated_notification:Fundraiser created successfully.`,
									'OK',
									'success'
								);
								localStorage.removeItem('start_fundraiser');
								localStorage.removeItem('formData');
								return response;
							}
						}),
						mergeMap((response: any) => {
							if (response['data'] && response['data']['id']) {
								this.fundraiserLocalId = response?.data?.id;
							} else {
								this.fundraiserLocalId = null;
							}

							let backgroundObject;
							let backgroundVideoObject;
							if (localImageBlob) {
								backgroundObject = {
									image: this.dataURItoBlob(localImageBlob),
									slug: response['data']['slug'],
								};
							} else if (this.videoPath) {
								backgroundVideoObject = {
									video: this.videoPath,
									slug: response['data']['slug'],
								};
								const defaultBackground = Tools.getBase64_FundraiserDefaultBg();
								backgroundObject = {
									image: this.dataURItoBlob(defaultBackground),
									slug: response['data']['slug'],
								};
							} else {
								const defaultBackground = Tools.getBase64_FundraiserDefaultBg();
								backgroundObject = {
									image: this.dataURItoBlob(defaultBackground),
									slug: response['data']['slug'],
								};
							}

							const backgroundAPICall =
								this.fundraiserService.uploadFundraiserBackground(
									backgroundObject
								);

							if (this.videoPath && this.videoPath.toString().length > 0) {
								const backgroundVideoAPICall =
									this.fundraiserService.addVideoBackground(
										backgroundVideoObject
									);
								return forkJoin([backgroundAPICall, backgroundVideoAPICall]);
							} else {
								return forkJoin([backgroundAPICall]);
							}
						}),
						mergeMap(() => {
							const rawDescription =
								this.createFundraiserForm.get('description')?.value || '';
							const contentBody = {
								slug: this.createFundraiserForm.get('custom_url')?.value,
								content: `<p>${rawDescription}</p>`,
								description: rawDescription,
								appeal: '',
							};
							return this.fundraiserService.updateFundraiserDescription(
								contentBody
							);
						})
					)
					.subscribe((result: any) => {
						if (!this.fundraiserLocalId) {
							console.error('Fundraiser ID is null');
							return;
						}

						const profileId = this.profileId || '0';
						const userId =
							JSON.parse(localStorage.getItem('user') || '{}')?.id || 0;

						this.analyticsService.sendConversion(profileId).subscribe({
							next: (conversionRes) => {
								const convData = conversionRes?.data;
								const basePayload = {
									profile_id: profileId,
									user_id: userId,
									fundraiser_id: this.fundraiserLocalId,
									profile_name: this.profileName,
									email: this.profileEmail,
									phone: this.profilePhone,
									session_source: convData?.utm_source || '',
									click_id: convData?.utm_id || '',
									conversion_id: convData?.conversion_id || '',
									conversion_label: convData?.utm_campaign || '',
									campaign_source: convData?.utm_source || '',
									campaign_name: convData?.utm_campaign || '',
									fundraiser_name:
										this.createFundraiserForm.get('title')?.value,
								};

								this.analyticsService.fireAnalyticsEvent('Fundraiser_Created', {
									event: 'fundraiser_created',
									...basePayload,
								});

								if (isFirstFundraiser) {
									this.analyticsService.fireAnalyticsEvent(
										'User_First_Fundraiser_Created',
										{
											event: 'User_First_Fundraiser_Created',
											...basePayload,
										}
									);
								}
							},
							error: (err) => {
								console.error('Error fetching conversion data:', err);
								const fallbackPayload = {
									profile_id: profileId,
									user_id: userId,
									fundraiser_id: this.fundraiserLocalId,
									profile_name: this.profileName,
									email: this.profileEmail,
									phone: this.profilePhone,
									fundraiser_name:
										this.createFundraiserForm.get('title')?.value,
								};

								this.analyticsService.fireAnalyticsEvent('Fundraiser_Created', {
									event: 'fundraiser_created',
									...fallbackPayload,
								});

								if (isFirstFundraiser) {
									this.analyticsService.fireAnalyticsEvent(
										'User_First_Fundraiser_Created',
										{
											event: 'User_First_Fundraiser_Created',
											...fallbackPayload,
										}
									);
								}
							},
						});

						this.router.navigate([
							'fundraising/' +
								this.createFundraiserForm.get('custom_url')?.value,
						]);
					});
			}
		} else {
			this.isLoading = false;
			this.notificationService.openNotification(
				$localize`:@@connect_fundraiser_errorsInForm_notification:There are errors in your form. Kindly fill the form properly.`,
				'OK',
				'error'
			);
		}
	}
	receiveForm(form: any) {
		this.receivedForm = form;
	}
	receiveFormValidity(validity: boolean) {
		this.isFormValid = validity;
	}

	removeEmojis(text: string): string {
		// Replace spaces with a placeholder
		let result = text.replace(/\s+/g, 'ANTRIKSHY');
		// Match emojis and special characters, excluding hyphens manually
		const emojiAndSpecialCharsRegex =
			/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
		// Remove emojis
		result = result.replace(emojiAndSpecialCharsRegex, '');
		// Remove punctuation and symbols except hyphens
		result = result.replace(/[^\w\s-]/g, '');

		// Restore hyphens
		result = result.replace(/ANTRIKSHY/g, '-');
		result = result.replace(/-+/g, '-'); // Collapse multiple hyphens

		return result.trim();
	}

	browseFundraiser() {
		window.open(
			this.router.serializeUrl(
				this.router.createUrlTree([`${this.currentLanguageCode}/search`])
			),
			'_blank'
		);
	}

	get descriptionControl(): FormControl {
		return this.createFundraiserForm.get('description') as FormControl;
	}

	isValidVideoURL(): AsyncValidatorFn {
		return (control: AbstractControl): Promise<ValidationErrors | null> => {
			const url = control.value;
			return new Promise((resolve) => {
				if (!url || url.trim().length === 0) return resolve(null);

				const youtubePattern =
					/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;
				const vimeoPattern =
					/^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)(?:\S+)?$/;

				if (youtubePattern.test(url)) {
					resolve(null);
				} else if (vimeoPattern.test(url)) {
					if (/vimeo\.com\/\d+$/.test(url)) {
						resolve(null);
					} else {
						resolve({ vimeoInvalidId: true });
					}
				} else {
					resolve({ invalid: true });
				}
			});
		};
	}

	handleVideoUrlChange(): void {
		const url = this.createFundraiserForm.get('VideoName')?.value || '';
		const iframeHtml = this.checkVideoUrl(url);

		if (iframeHtml === 'unknown') {
			this.videoPath = null;
			this.youtubeIframe = undefined;
			return;
		}

		if (this.imagePath) {
			this.mediaSwitchTarget = 'video';
			this.showMediaSwitchPopup = true;
			this.pendingVideoUrl = url;
			this.pendingIframeHtml = iframeHtml;
		} else {
			this.videoPath = url;
			this.youtubeIframe = iframeHtml;
		}
	}

	backToLastPage(): void {
		this.router.navigate(['/fundraising/start'], {
			queryParams: { step: 2 },
		});
		this.scrollToOffsetTop();
	}

	goToNextStep() {
		this.step = 4;
		this.saveFormToLocalStorage();
		this.scrollToOffsetTop();
	}

	saveFormToLocalStorage() {
		const existingData = localStorage.getItem('start_fundraiser');
		let updatedData: any = {};

		if (existingData) {
			try {
				updatedData = JSON.parse(existingData);
			} catch (e) {
				console.error('Error parsing existing start_fundraiser data:', e);
			}
		}

		// Update with form values
		const formValue = this.createFundraiserForm.value;
		updatedData.title = formValue.title;
		updatedData.custom_url = formValue.custom_url;
		updatedData.description = formValue.description;
		updatedData.video = formValue.VideoName;
		updatedData.imagePath = formValue.imagePath;
		updatedData.imagePath_blob = formValue.imagePath_blob;

		localStorage.setItem('start_fundraiser', JSON.stringify(updatedData));
	}

	goToPreviousStep() {
		this.step = 3;
		this.scrollToOffsetTop();
	}

	showDescriptionInput(): void {
		this.descriptionInputVisible = true;
		// Wait for the textarea to appear in the DOM
		setTimeout(() => {
			this.descriptionTextarea?.nativeElement?.focus();
		});
	}

	cancelMediaSwitch() {
		this.showMediaSwitchPopup = false;
		this.mediaSwitchTarget = null;
		this.pendingVideoUrl = null;
		this.pendingIframeHtml = null;
	}

	confirmMediaSwitch() {
		// Load current local storage data
		const formData = JSON.parse(localStorage.getItem('formData') || '{}');

		if (
			this.mediaSwitchTarget === 'video' &&
			this.pendingVideoUrl &&
			this.pendingIframeHtml
		) {
			// Clear image-related fields
			this.imagePath = null;
			this.imagePath_blob = null;
			this.createFundraiserForm.get('imagePath')?.setValue(null);
			this.createFundraiserForm.get('imagePath_blob')?.setValue(null);

			// Set video-related fields
			this.videoPath = this.pendingVideoUrl;
			this.youtubeIframe = this.pendingIframeHtml;

			// Update form controls
			this.createFundraiserForm.get('VideoName')?.setValue(this.videoPath);

			// Update local storage
			formData.imagePath = '';
			formData.imagePath_blob = '';
			formData.video = this.videoPath;
			localStorage.setItem('formData', JSON.stringify(formData));
		} else if (this.mediaSwitchTarget === 'image') {
			// Clear video-related fields
			this.videoPath = null;
			this.youtubeIframe = undefined;
			this.createFundraiserForm.get('VideoName')?.setValue(null);

			// Update local storage to clear video
			formData.video = '';
			localStorage.setItem('formData', JSON.stringify(formData));

			// Open image cropper dialog (image fields will be updated in openImageCropperDialog)
			this.openImageCropperDialog();
		}

		// Reset media switch popup
		this.cancelMediaSwitch();
	}

	handleScroll() {
		const scrollY = window.scrollY;
		const viewportHeight = window.innerHeight;
		const fullHeight = document.body.scrollHeight;

		const distanceFromBottom = fullHeight - (scrollY + viewportHeight);

		if (distanceFromBottom <= 20) {
			this.bottomOffset = 'bottom-[52px] shadow-[0_-1px_0_0_#e5e7eb]';
		} else {
			this.bottomOffset = 'bottom-0 shadow-[0_-1px_0_0_#e5e7eb]';
		}
	}

	scrollToOffsetTop(offset: number = 120): void {
		if (window.innerWidth <= 599) {
			window.scrollTo({
				top: offset,
				behavior: 'smooth',
			});
		}
	}
}
